import { ForeignScansMeta } from "../types/location"
import { WorldMapPoint } from "./worldMapPoints"
import { distanceMeters } from "./geo"

export function isWorldMapPointInRange(
  point: WorldMapPoint,
  coords: { lat: number; lng: number }
): boolean {
  return (
    distanceMeters(coords.lat, coords.lng, point.lat, point.lng) <= point.radiusM
  )
}

export function canActivateWorldMapPoint(
  point: WorldMapPoint,
  coords: { lat: number; lng: number } | null,
  foreignScans: ForeignScansMeta | null
): boolean {
  if (!coords || !point.isAvailable) return false
  if (!isWorldMapPointInRange(point, coords)) return false

  if (point.kind === "treasure") {
    if (!point.treasure?.isActiveNow) return false
  }

  if (
    point.kind === "scan" &&
    point.isOwnCity === false &&
    foreignScans != null &&
    foreignScans.remaining <= 0
  ) {
    return false
  }

  return true
}

export function findNearestActionableWorldMapPoint(
  points: WorldMapPoint[],
  coords: { lat: number; lng: number } | null,
  foreignScans: ForeignScansMeta | null
): WorldMapPoint | null {
  if (!coords) return null

  let nearest: WorldMapPoint | null = null
  let nearestDist = Number.POSITIVE_INFINITY

  for (const point of points) {
    if (!canActivateWorldMapPoint(point, coords, foreignScans)) continue
    const dist = distanceMeters(coords.lat, coords.lng, point.lat, point.lng)
    if (dist < nearestDist) {
      nearestDist = dist
      nearest = point
    }
  }

  return nearest
}

/** Все точки в радиусе действия, от ближней к дальней. */
export function listActionableWorldMapPoints(
  points: WorldMapPoint[],
  coords: { lat: number; lng: number } | null,
  foreignScans: ForeignScansMeta | null,
  limit = 6
): WorldMapPoint[] {
  if (!coords) return []

  return points
    .filter((point) => canActivateWorldMapPoint(point, coords, foreignScans))
    .map((point) => ({
      point,
      dist: distanceMeters(coords.lat, coords.lng, point.lat, point.lng),
    }))
    .sort((a, b) => a.dist - b.dist)
    .slice(0, limit)
    .map((entry) => entry.point)
}

export function proximityActionLabel(kind: WorldMapPoint["kind"]): string {
  if (kind === "scan") return "Сканировать"
  if (kind === "boss") return "Атаковать"
  if (kind === "worldboss") return "Мировой босс"
  if (kind === "postoffice") return "Почта"
  if (kind === "treasure") return "Забрать"
  if (kind === "bank") return "Банк"
  if (kind === "cityhall") return "Ратуша"
  if (kind === "hotel") return "Гостиница"
  if (kind === "hangar") return "Ангар"
  if (kind === "boostershop") return "Маршрут"
  return "Лавка"
}

export type NearbyWorldMapPoint = {
  point: WorldMapPoint
  distanceM: number
  actionable: boolean
}

export function listNearestWorldMapPoints(
  points: WorldMapPoint[],
  coords: { lat: number; lng: number } | null,
  foreignScans: ForeignScansMeta | null,
  limit = 5
): NearbyWorldMapPoint[] {
  if (!coords) return []

  return points
    .map((point) => ({
      point,
      distanceM: distanceMeters(coords.lat, coords.lng, point.lat, point.lng),
      actionable: canActivateWorldMapPoint(point, coords, foreignScans),
    }))
    .sort((a, b) => {
      if (a.actionable !== b.actionable) return a.actionable ? -1 : 1
      return a.distanceM - b.distanceM
    })
    .slice(0, limit)
}
